import React from "react";
import { withTheme } from "styled-components";

export const OkPicturePreviewIcon = ({ theme, ...props }) => (
  <svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Icon / check">
      <circle
        id="Oval 2"
        cx="22"
        cy="22"
        r="20.9375"
        stroke="white"
        strokeWidth="1.875"
      />
      <g id="icon/check">
        <path
          id="Line Copy 8"
          d="M11.5 22.1346L20.7308 29.5192L35.5 14.75"
          stroke="white"
          strokeWidth="2.5"
        />
      </g>
    </g>
  </svg>
);

export default withTheme(OkPicturePreviewIcon);
